import { useMemo } from "react";
import { Layout } from "antd";
import {
  INavigationContext,
  NavigationContext,
  resolveViewComponent,
  useAppContext,
  useDashboardLayoutsContext,
  useDashboardPanelContext,
  ViewProvider,
} from "@data-root/react";
import { PanelHeader } from "@/views/DashboardView/components/panel-header";

const { Header, Content } = Layout;

export const Panel = () => {
  const { getView } = useAppContext();

  const { hasLayoutFor, createLayoutFor } = useDashboardLayoutsContext();
  const { layout, groupId, params, setParam } = useDashboardPanelContext();

  const view = useMemo(() => getView(layout.viewId), [layout.viewId, getView]);

  const Component = useMemo(() => resolveViewComponent(view.type), [view]);

  const navigation = useMemo<INavigationContext>(
    () => ({
      navigation: {
        navigate(viewId, params) {
          // if (!hasLayoutFor(viewId))
          //   createLayoutFor(viewId, groupId);

          const { tableId } = getView(viewId);

          Object.entries(params).forEach(([paramId, value]) =>
            setParam(tableId, paramId, value, value)
          );
        },
        canGoBack() {
          return false;
        },
        goBack() {
          return;
        },
        setParams(params) {
          Object.entries(params).forEach(([paramId, value]) =>
            setParam(view.tableId, paramId, value, value)
          );
        },
        getParam(param, defaultValue) {
          return params.find((p) => p.id === param)?.value ?? defaultValue;
        },
        getViewId() {
          return layout.viewId;
        },
        getParent(id) {
          return this;
        },
      },
    }),
    [params, setParam, getView, layout.viewId, view.tableId]
  );

  console.log("params", layout.viewId, params);

  return (
    <NavigationContext.Provider value={navigation}>
      <Layout style={{ height: "100%" }}>
        <Header
          className="panel-draggable"
          style={{
            height: "35px",
            lineHeight: "35px",
            padding: 1,
          }}
        >
          <PanelHeader />
        </Header>
        <Content className="panel-non-draggable">
          <ViewProvider view={view}>
            <Component view={view} />
          </ViewProvider>
        </Content>
      </Layout>
    </NavigationContext.Provider>
  );
};
